@if(bucket || businessId){
<p-fileUpload [chooseLabel]="chooseLabel" name="file" [url]="'/api/file/upload'+(bucket? '/'+bucket:'')" [accept]="accept"
  [maxFileSize]="maxFileSize" [headers]="headers" (onUpload)="onUpload.emit($event.originalEvent.body.paths)"
  [auto]="auto" [multiple]="false" [mode]="mode">
</p-fileUpload>
}